import { Link } from 'react-router-dom';
import Typography from '@mui/joy/Typography';
import Stack from '@mui/joy/Stack';

import RoleStack from 'components/RoleStack';

import ClockTotalChip from './ClockTotalChip';

export default function ClockTotalSidebar({ total_seconds }: { total_seconds: number }) {
    if (!total_seconds) return null;

    return (

        <RoleStack role="assistant" spacing={1} direction="row" alignItems="center" justifyContent="center">

            <Stack alignItems="center">
                <Typography level="body-xs">
                    Total Time Worked
                </Typography>
                <Typography level="body-sm">
                <Link to="clocks">
                    <ClockTotalChip total_seconds={total_seconds} />
                    </Link>
                </Typography>
            </Stack>

        </RoleStack>
    );
}
